import { render, staticRenderFns } from "./CarouselManager.vue?vue&type=template&id=4530073d&scoped=true&"
import script from "./CarouselManager.vue?vue&type=script&lang=ts&"
export * from "./CarouselManager.vue?vue&type=script&lang=ts&"
import style0 from "./CarouselManager.vue?vue&type=style&index=0&id=4530073d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4530073d",
  null
  
)

export default component.exports